import {
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_VOD,
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
} from 'src/AAFPlayer/constants.js';

const CONTENT_TYPES_ON_LIVE: string[] = [
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
];
const CONTENT_TYPES_VOD: string[] = [AAF_CONTENT_IS_NPVR, AAF_CONTENT_IS_VOD];

interface IDefaultValuesModal {
    contentStreamType?: string;
    controlTime?: number;
    enabled?: boolean;
    episodeNumber?: string | number;
    episodesCount?: number;
    group_id?: string;
    isSerie?: boolean;
    playing?: boolean;
    season_id?: string | null;
    series_id?: string | null;
    streamContentType?: string;
    timeEndStartOver?: number;
    totalEpisodes?: number;
}

const DEFAULT_VALUES_REDUCE: IDefaultValuesModal = {
    contentStreamType: '',
    controlTime: 0,
    enabled: false,
    episodeNumber: -1,
    episodesCount: 0,
    group_id: '',
    isSerie: false,
    playing: false,
    season_id: null,
    series_id: null,
    streamContentType: '',
    timeEndStartOver: 0,
    totalEpisodes: 4,
};

interface IContentKeys {
    title: {
        [AAF_CONTENT_IS_VOD]: string,
        [AAF_CONTENT_IS_NPVR]: string,
        [AAF_CONTENT_IS_TV]: string,
        [AAF_CONTENT_IS_STARTOVER]: string,
        [AAF_CONTENT_IS_CATCHUP]: string,
    },
    continue: {
        [AAF_CONTENT_IS_VOD]: string,
        [AAF_CONTENT_IS_NPVR]: string,
        [AAF_CONTENT_IS_TV]: string,
        [AAF_CONTENT_IS_STARTOVER]: string,
        [AAF_CONTENT_IS_CATCHUP]: string,
    },
    exit: {
        [AAF_CONTENT_IS_VOD]: string,
        [AAF_CONTENT_IS_NPVR]: string,
        [AAF_CONTENT_IS_TV]: string,
        [AAF_CONTENT_IS_STARTOVER]: string,
        [AAF_CONTENT_IS_CATCHUP]: string,
    },
    live: {
        [AAF_CONTENT_IS_VOD]: string,
        [AAF_CONTENT_IS_NPVR]: string,
        [AAF_CONTENT_IS_TV]: string,
        [AAF_CONTENT_IS_STARTOVER]: string,
        [AAF_CONTENT_IS_CATCHUP]: string,
    }
}

const CONTENT_KEYS: IContentKeys = {
    title: {
        [AAF_CONTENT_IS_VOD]: "PlayerVOD_AlertaContinuarViendo_Titulo",
        [AAF_CONTENT_IS_NPVR]: "PlayerVOD_AlertaContinuarViendo_Titulo",
        [AAF_CONTENT_IS_TV]: "TVenVivo_AlertaContinuarViendo_Ahora_Titulo",
        [AAF_CONTENT_IS_STARTOVER]: "TVenVivo_AlertaContinuarViendo_YaEmitido_Titulo",
        [AAF_CONTENT_IS_CATCHUP]: "TVenVivo_AlertaContinuarViendo_YaEmitido_Titulo",
    },
    continue: {
        [AAF_CONTENT_IS_VOD]: "PlayerVOD_AlertaContinuarViendo_TextoBotonPrimario",
        [AAF_CONTENT_IS_NPVR]: "PlayerVOD_AlertaContinuarViendo_TextoBotonPrimario",
        [AAF_CONTENT_IS_TV]: "TVenVivo_AlertaContinuarViendo_Ahora_TextoBotonPrimario",
        [AAF_CONTENT_IS_STARTOVER]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonPrimario",
        [AAF_CONTENT_IS_CATCHUP]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonPrimario",
    },
    exit: {
        [AAF_CONTENT_IS_VOD]: "PlayerVOD_AlertaContinuarViendo_TextoBotonSecundario",
        [AAF_CONTENT_IS_NPVR]: "PlayerVOD_AlertaContinuarViendo_TextoBotonSecundario",
        [AAF_CONTENT_IS_TV]: "TVenVivo_AlertaContinuarViendo_Ahora_TextoBotonSecundario",
        [AAF_CONTENT_IS_STARTOVER]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonSecundario2",
        [AAF_CONTENT_IS_CATCHUP]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonSecundario2",
    },
    live: {
        [AAF_CONTENT_IS_VOD]: "",
        [AAF_CONTENT_IS_NPVR]: "",
        [AAF_CONTENT_IS_TV]: "",
        [AAF_CONTENT_IS_STARTOVER]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonSecundario1",
        [AAF_CONTENT_IS_CATCHUP]: "TVenVivo_AlertaContinuarViendo_YaEmitido_TextoBotonSecundario1",
    }
}

export { CONTENT_TYPES_ON_LIVE, CONTENT_TYPES_VOD, DEFAULT_VALUES_REDUCE, CONTENT_KEYS, IDefaultValuesModal };



// WEBPACK FOOTER //
// ./src/components/Modal/constants/ModalInactivity/constants.ts